<div style="margin: 10px;">

  <!--<button type="button" pButton icon="fa fa-refresh" (click)="refresh()" [disabled]="false"
label="Refresh" title="Refresh client details"></button>

<br />
<br />-->

@if (!isClientRegistered) {
  <div
    style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: x-large;">
    No client is currently registered for this agent
  </div>
}

@if (isClientRegistered) {
  <div>
    <b style='font-size:24px'>Client Details</b>
    <br />
    <br />
    <form>
      <div class="mb-3 row">
        <span class="col-lg-2">Client ID:</span>
        <span class="col-lg-4">{{clientId}}</span>
      </div>
      <div class="mb-3 row">
        <span class="col-lg-2">Client Machine:</span>
        <span class="col-lg-4">{{clientMachine}}</span>
      </div>
      <div class="mb-3 row">
        <span class="col-lg-2">Last Config Poll Time:</span>
        <span class="col-lg-4">{{formatDateHm(lastConfigPollTime)}}</span>
      </div>
    </form>
    <button type="button" pButton class="p-button-danger" (click)="unregister()" [disabled]="false"
      label="Unregister Agent Client">
      <i class="pi pi-trash" style="margin-right: 5px;"></i>
    </button>
  </div>
}

<confirmation-dialog message="Are you sure you want to unregister this client?"
  [display]="displayUnregisterConfirm"
  (onYes)="doUnregister()" (onNo)="cancelUnregister()">
</confirmation-dialog>

</div>
